export default __webpack_public_path__ + "static/media/empty-search-result.99ba3d46.svg";